import { CalendarType, SHORT_DATE_FORMAT } from '$constants'
import dayjs, { Dayjs } from 'dayjs'
import { setCompanyDayStartToDate } from '$utils'
import { SelectOption } from '../types'

export interface Calendar {
  id: string
  name: string
  type: CalendarType
  periodStartDate: Dayjs
}

// Function to apply transformations to Calendar object
export const transformCalendarOnGet = (calendar: Calendar): Calendar => {
  return {
    ...calendar,
    periodStartDate: setCompanyDayStartToDate(dayjs(calendar.periodStartDate)),
  }
}

export const getCalendarsAsOptions = (calendars: Calendar[]): SelectOption[] =>
  calendars.map((calendar) => {
    return {
      label: `${calendar.name} - Starting ${calendar.periodStartDate.format(
        SHORT_DATE_FORMAT
      )}`,
      value: calendar.id,
    }
  })
